import { Component, OnInit } from '@angular/core';
import { FormGroup,FormBuilder, Validators } from '@angular/forms';

import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { Image } from '../../../../../images/images'
import { PhotoAlbumService } from 'src/app/shared/API-Service/services/photo-album.service';
import { GovernorateService } from 'src/app/shared/API-Service/services/governorate.service';


@Component({
  selector: 'app-insert-photo-album',
  templateUrl: './insert-photo-album.component.html',
  styleUrls: ['./insert-photo-album.component.css']
})
export class InsertPhotoAlbumComponent implements OnInit {
  recordtoupdate: any;
  city:any ;
 photoalbumForm : FormGroup;
photoalbumFormData : FormData;
update:boolean = false;
button:boolean = false;
Image: File;
imageLogo: string;
img : string = Image;
selectedItemsGovernates:any[]=[];
Governates:any;
dropdownSettings: any = {};

  constructor(private GovernorateService:GovernorateService,private _PhotoAlbumService:PhotoAlbumService,private _Router:Router,private _FormBuilder:FormBuilder) {
    this.imageLogo="../../../../../assets/images/upload.png"

   }

  ngOnInit(): void {
    this.initiate();
    this.checkEdit();
    this.GetGovernorate();
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'titleAr',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
     
  };
  }

  GetGovernorate(){
    this.GovernorateService.GetGovernorate().subscribe(res=>{
      this.Governates=res.data;
    })
  }
  initiate(){
    this.photoalbumForm = this._FormBuilder.group({
      title: [''],
      titleAr: ['', Validators.required],
      order : ['', Validators.required],
      photoalbumImage : ['', Validators.required],
      GovernatesIds:['',Validators.required]
    });
  }
  insertappenddata(){
    this.photoalbumFormData = new FormData();
    this.photoalbumFormData.append("TitleAr", this.photoalbumForm.value.titleAr);
    this.photoalbumFormData.append("Title", this.photoalbumForm.value.title);
    this.photoalbumFormData.append("Order", this.photoalbumForm.value.order);
    this.photoalbumFormData.append("PhotoAlbumImage", this.Image);
    this.selectedItemsGovernates.forEach(element => {
      this.photoalbumFormData.append("GovernoratesIds", element.id);  
    });

  }
  updateappenddata(){
    this.photoalbumFormData = new FormData();
    this.photoalbumFormData.append("Id", this.recordtoupdate.id);
    this.photoalbumFormData.append("TitleAr", this.photoalbumForm.value.titleAr);
    this.photoalbumFormData.append("Title", this.photoalbumForm.value.title);
    this.photoalbumFormData.append("Order", this.photoalbumForm.value.order);
    this.photoalbumFormData.append("PhotoAlbumImage", this.Image);
    this.selectedItemsGovernates.forEach(element => {
      this.photoalbumFormData.append("GovernoratesIds", element.id);  
    });
  }
  checkEdit() {
    this._PhotoAlbumService.Data.subscribe((res) => {
      if (res != null) {
        this.photoalbumForm = this._FormBuilder.group({
          titleAr: [res.titleAr, Validators.required],
          title: [res.title],
          order : [res.order, Validators.required],
          GovernatesIds:['',Validators.required],
          photoalbumImage : [res.image]
        });
        this.imageLogo = this.img + res.image;
        this.selectedItemsGovernates=res.governorates;
        // let driver = this.getById(res);
        this.update = true;
        this.recordtoupdate = res ;
      
      } else {
        // this.initiate();
      }
     
    });
  }
   // imgFile
   getLogoUrl(event: any) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      this.Image = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.imageLogo = reader.result as string;
        this.photoalbumForm.get("photoalbumImage").setValue(this.Image);

        // this.logoForm?.append("image", this.Image);
      };
    }
  }
  get fc() {
    return this.photoalbumForm.controls;
  }

  onSubmit(){
    this.button = true;
   if(this.update == false && this.photoalbumForm.status == "VALID"){
    this.insertappenddata();
    this._PhotoAlbumService.CreatePhotoAlbum(this.photoalbumFormData).subscribe((res) => {
      Swal.fire({
        icon: "success",
        title: "تم الحفظ بنجاح",
        showConfirmButton: false,
        timer: 1500,
      });
      this.photoalbumForm.reset();
      this._Router.navigate(['/content/admin/ViewPhotoAlbum']);
    },(err) => {
      Swal.fire({
        icon: 'error',
        title: 'خطأ',
        text:err.error.message    
      }) 
      this.button = false ;
    }, () => {
    })
   } else if(this.photoalbumForm.status == "VALID"){
    this.updateappenddata();
    this._PhotoAlbumService.UpdatePhotoAlbum(this.photoalbumFormData).subscribe((res) => {
      Swal.fire({
        icon: "success",
        title: "تم التعديل بنجاح",
        showConfirmButton: false,
        timer: 1500,
      });
      this.photoalbumForm.reset();
      this._Router.navigate(['/content/admin/ViewPhotoAlbum']);
    },(err) => {
      Swal.fire({
        icon: 'error',
        title: 'خطأ',
        text:err.error.message    
      }) 
    }, () => {
    })
   }else {
    Swal.fire({
      icon: 'error',
      title: 'خطأ',
      text:"بالرجاء التأكد من ملئ جميع الحقول"   
    })
    this.photoalbumForm.markAllAsTouched();
    this.button = false;
   }
  }
  ngOnDestroy(){
    this._PhotoAlbumService.Data.next(null);
     }
}
